import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BannerSingleProduct from './_banner-single-product/component';
import BannerCollection from './_banner-collection/component';
import BannerHero from './_banner-hero/component';
import { promotionClickGoogleTag } from '@utils/analytics.js';

import './styles/styles.scss';

class DynamicBanner extends Component {
  get transMap() {
    return {
      singleProduct: BannerSingleProduct,
      default: BannerSingleProduct,
      hero: BannerHero,
      timedDeal: BannerSingleProduct,
      collection: BannerCollection,
    };
  }

  get store() {
    return this.props.store;
  }

  get bannerVariant() {
    return this.transMap[this.props.variant] || this.transMap.default;
  }

  openSidePanel = (e) => {
    e.preventDefault();

    const { sidePanelLinkText, sidePanel } = this.props;
    this.store.modal.openModal('sidepanel', 'left', {
      title: sidePanelLinkText,
      component: <div className="banner-content">{sidePanel}</div>,
    });
  };

  googleTagMethods = () => {
    return {
      pushPromotionGoogleTag: (promotion) => {
        this.props.store.pushToDataLayer(promotionClickGoogleTag(promotion));
      },
    };
  };

  render() {
    const BannerVariant = this.bannerVariant;
    const { sidePanelLinkText } = this.props;

    return (
      <div className="dynamic-banner">
        <BannerVariant
          googleTagMethods={this.googleTagMethods}
          {...this.props}
        />
        {sidePanelLinkText && (
          <div className="side-panel-link" onClick={this.openSidePanel}>{sidePanelLinkText}</div>
        )}
      </div>
    );
  }
}

DynamicBanner.propTypes = {
  store: PropTypes.object,
  variant: PropTypes.string,
  sidePanelLinkText: PropTypes.string,
  sidePanel: PropTypes.string,
};

export default DynamicBanner;
